export default {
    400: 'Não foi possível processar a requisição',
    403: 'Acesso negado',
    404: 'Recurso não encontrado',
    413: 'A requisição excede o tamanho máximo permitido',
    500: 'Ocorreu um erro',
}
